import type { BaseQueryFn } from '@reduxjs/toolkit/query'
import type { AxiosRequestConfig } from 'axios'

import { httpRequest } from '../httpRequest'

export type AxiosBQ = BaseQueryFn<
	{
		data?: AxiosRequestConfig['data']
		headers?: AxiosRequestConfig['headers']
		method?: AxiosRequestConfig['method']
		params?: AxiosRequestConfig['params']
		url: string
	},
	unknown,
	unknown
>

const axiosBaseQuery =
	({ baseUrl }: { baseUrl: string } = { baseUrl: '' }): AxiosBQ =>
	async ({ data, headers, method, params, url }) => {
		try {
			const result = await httpRequest({
				data,
				headers,
				method,
				params,
				url: baseUrl + url
			})
			return { data: result?.data }
		} catch (axiosError) {
			return {
				error: axiosError
			}
		}
	}

export { axiosBaseQuery }
